import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Calendar from "./calendar/Calendar";
import Meta from "../../components/Meta";
import AppContext from "../../../context";

import Data from "../../../repository";

function Book(){

	const navigate = useNavigate();
	const params = useParams();
	const context = useContext(AppContext);

	const [studios, setStudios] = useState([]);
	const [selectedSessions, setSelectedSessions] = useState([]);
	const [booking, setBooking] = useState(false);
	const [error, setError] = useState("");

	useEffect(async () => {
		setStudios(await fetchStudios());
	}, []);

	const maxWeek = context.user?.paidExtrasActive ? 5 : 3;

	useEffect(async () => {
		if(studios.length){
			let studio = params.studio ? params.studio : studios[0]._id;
			let week = params.week ? parseInt(params.week) : 0;

			if(!studios.map((studio) => { return studio._id }).includes(studio)) studio = studios[0]._id;
			if(week < 0 || maxWeek < week || !Number.isInteger(week)) week = 0;

			if(params.studio !== studio || parseInt(params.week) !== parseInt(week)) navigate(`${studio}/sessions/${week}`);
		}
	}, [studios, params, maxWeek])

	const fetchStudios = async () => {
		const result = await Data.fetchStudios();
		return result.data;
	}

	const setStudio = (studio) => {
		navigate(`${studio}/sessions/${params.week}`);
	}

	const setWeek = (week) => {
		week = parseInt(week);
		navigate(`${params.studio}/sessions/${week}`);
	}

	const getSessionKey = (session) => {
		return `${session.studio?._id}-${session.start}-${session.end}`;
	}

	const toggleSession = (session) => {
		setError("");
		const key = getSessionKey(session);
		setSelectedSessions((current) => {
			if(current.some((selected) => getSessionKey(selected) === key)) {
				return current.filter((selected) => getSessionKey(selected) !== key);
			}

			return [...current, session];
		});
	}

	const removeSession = (session) => {
		const key = getSessionKey(session);
		setSelectedSessions((current) => current.filter((selected) => getSessionKey(selected) !== key));
	}

	const clearCart = () => {
		setError("");
		setSelectedSessions([]);
	}

	const createBulkBookings = async () => {
		try {
			setError("");
			setBooking(true);
			await Data.createBulkBookings(selectedSessions);
			setSelectedSessions([]);
			context.fetchUser();
			navigate("/dashboard/bookings?success=true");
		} catch(error) {
			setError(error.response?.data?.message || "Failed to create bookings.");
			setBooking(false);
		}
	}

	if(!studios.length || !params.studio || !params.week) return null;

	return (
		<>
			<Meta title="New Booking" />

			<Calendar
				studio={params.studio}
				setStudio={setStudio}
				week={parseInt(params.week)}
				setWeek={setWeek}
				studios={studios}
				selectedSessions={selectedSessions}
				toggleSession={toggleSession}
				removeSession={removeSession}
				clearCart={clearCart}
				createBulkBookings={createBulkBookings}
				booking={booking}
				error={error}
				user={context.user}
				domain={context.domain}
				maxWeek={maxWeek}
			/>
		</>
	)
}

export default Book;
